"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdBarContent = exports.AdBarContainer = void 0;
var _react = require("@linaria/react");
var _core = require("@linaria/core");
"ajnymdy";
const AdBarContainer = exports.AdBarContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "AdBarContainer",
  class: "a13of1h9"
});
const AdBarContent = exports.AdBarContent = /*#__PURE__*/(0, _react.styled)("div")({
  name: "AdBarContent",
  class: "a1cayg02"
});